module.exports = __webpack_public_path__ + "static/media/jetson_one_render_18.d7b5a83a.jpg";